import React from "react";
import { connect } from "react-redux";

import Checkout from "state/school_money/entities/Checkout";
import { getCheckoutStatus } from "state/school_money/selectors";

import "./PaymentStatus.css";

class PaymentStatus extends React.Component {

  render() {
    const processingStatusClassNames = ["payment-status__pending"];
    const completedStatusClassNames = ["payment-status__pending"];
    const status = this.props.status;

    if(status === Checkout.status.PROCESSING) {
      processingStatusClassNames.push("payment-status__complete");
    }

    if(status === Checkout.status.COMPLETED) {
      processingStatusClassNames.push("payment-status__complete");
      completedStatusClassNames.push("payment-status__complete");
    }

    return (
      <div className="payment-status__wrapper">
        <div className="payment-status__pending payment-status__complete"></div>
        <div className="payment-status__status-text">Card Details</div>
        <div className="payment-status__separator"><hr/></div>
        <div className={processingStatusClassNames.join(" ")}></div>
        <div className="payment-status__status-text">Processing</div>
        <div className="payment-status__separator"><hr/></div>
        <div className={completedStatusClassNames.join(" ")}></div>
        <div className="payment-status__status-text">Complete!</div>
      </div>
    )
  }
}

export default connect(
  (state) => ({
    status: getCheckoutStatus(state)
  })
)(PaymentStatus);



// WEBPACK FOOTER //
// ./src/components/school_money/basket/checkout/PaymentStatus.js